<template>
  <div v-bem>
    <div v-bem:content>
      <p>Bienvenue <strong>{{this.tradeCar.name}}</strong></p>
      <p>La cotation de votre <strong>{{this.tradeCar.brand}} {{this.tradeCar.model}}</strong> est prête et sera considéré comme apport de votre simulation de financement.</p>
      <p>Pour démarrer, merci de choisir le véhicule pour lequel vous voulez faire la simulation</p>
      <button @click="$emit('close-clicked')" class="button button--primary"><span class="button__text">Continuer</span></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TradeInPopin',
  computed: {
    tradeCar() { return this.$store.getters.tradeCar }
  }
}
</script>

<style scoped lang="scss">
.trade-in-popin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999999999;
  background-color: rgba($black, 0.7);
  &__content {
    text-align: center;
    @extend %transform-center;
    background-color: $white;
    width: 95%;
    max-width: rem(520);
    padding: rem(30) rem(16);
    p {
      margin: rem(16) 0;
      strong {
        text-transform: capitalize;
      }
    }
  }
}
</style>